import { h } from "preact";

import { classNames } from "../helpers.js";
import Icon from "./Icon.jsx";

function getCssWidth(value) {
  return Math.round(100 * (value / 3));
}

export default function Tag(props) {
  const classes = classNames("stars", props.tiny && "stars--tiny");
  const width = `${getCssWidth(props.rating)}%`;

  return (
    <span class={classes}>
      <span class="stars__empty">
        <Icon>star</Icon>
        <Icon>star</Icon>
        <Icon>star</Icon>
      </span>
      <span class="stars__full" style={{ width }}>
        <Icon>star</Icon>
        <Icon>star</Icon>
        <Icon>star</Icon>
      </span>
    </span>
  );
}
